//fetch
export const FETCH_PROJECT_HEATPROFILE_LIST =
  '@@Project-Heat-profile/fetch-project-heat-profile-list';

export const FETCH_PROJECT_HEATPROFILE_LIST_SUCCESS =
  '@@Project-Heat-profile/fetch-project-heat-list-success';

export const FETCH_PROJECT_HEATPROFILE_LIST_FAILURE =
  '@@Project-Heat-profile/fetch-project-heat-list-failure';

//add
export const ADD_PROJECT_HEATPROFILE_DETAILS =
  '@@Project-Heat-profile/add-project-heat-profile-details';

export const ADD_PROJECT_HEATPROFILE_DETAILS_SUCCESS =
  '@@Project-Heat-profile/add-project-heat-profile-details-success';

export const ADD_PROJECT_HEATPROFILE_DETAILS_FAILURE =
  '@@Project-Heat-profile/add-project-heat-profile-details-failure';

//update
export const UPDATE_PROJECT_HEATPROFILE_DETAILS =
  '@@Project-Heat-profile/update-project-heat-profile-details';

export const UPDATE_PROJECT_HEATPROFILE_DETAILS_SUCCESS =
  '@@Project-Heat-profile/update-project-heat-profile-details-success';

export const UPDATE_PROJECT_HEATPROFILE_DETAILS_FAILURE =
  '@@Project-Heat-profile/update-project-heat-profile-details-failure';

//delete
export const DELETE_PROJECT_HEATPROFILE_DETAILS =
  '@@Project-Heat-profile/delete-project-heat-profile-details';

export const DELETE_PROJECT_HEATPROFILE_DETAILS_SUCCESS =
  '@@Project-Heat-profile/delete-project-heat-profile-details-success';

export const DELETE_PROJECT_HEATPROFILE_DETAILS_FAILURE =
  '@@Project-Heat-profile/delete-project-heat-profile-details-failure';
